export default __webpack_public_path__ + "static/media/article1.1832f359.png";